import React from 'react';
import RouterLinkFormatter from './RouterLinkFormatter';
import { LinkProps } from './types';

const HistoryWalletLink: React.FC<LinkProps> = ({ id }) => {
	const LinkFormatter = RouterLinkFormatter((value: string) => `/history?wallet=${value}`);
	return <LinkFormatter value={id} record={{ value: id }} />;
};

export default HistoryWalletLink;
